<!-- eslint-disable vue/no-mutating-props -->
<!-- 订单详情、退款审核与订单核销的弹窗模块。表单状态由父页面集中管理。 -->
<template>
  <el-dialog
    :model-value="orderDetailVisible"
    title="订单详情"
    width="840px"
    @update:model-value="emit('update:orderDetailVisible', $event)"
  >
    <template v-if="selectedOrder">
      <div class="detail-grid">
        <article class="detail-card">
          <h3>基础信息</h3>
          <dl>
            <div><dt>订单号</dt><dd>{{ selectedOrder.orderNo }}</dd></div>
            <div><dt>用户</dt><dd>{{ selectedOrder.userNickname || '匿名用户' }}</dd></div>
            <div><dt>手机号</dt><dd>{{ selectedOrder.userPhone || '--' }}</dd></div>
            <div><dt>门店</dt><dd>{{ selectedOrder.storeName || selectedOrder.storeId }}</dd></div>
            <div><dt>配送方式</dt><dd>{{ getDeliveryTypeText(selectedOrder.deliveryType) }}</dd></div>
            <div><dt>下单时间</dt><dd>{{ selectedOrder.createdAt }}</dd></div>
            <div><dt>订单状态</dt><dd>{{ getOrderStatusText(selectedOrder.status) }}</dd></div>
            <div><dt>支付状态</dt><dd>{{ getPaymentStatusText(selectedOrder.paymentStatus) }}</dd></div>
            <div><dt>实付金额</dt><dd>{{ formatAmount(selectedOrder.paidAmount ?? selectedOrder.payableAmount) }}</dd></div>
            <div><dt>取餐码</dt><dd>{{ selectedOrder.pickupNo || '--' }}</dd></div>
          </dl>
        </article>
        <article class="detail-card">
          <h3>订单商品</h3>
          <div class="detail-items">
            <div v-for="item in selectedOrder.items" :key="item.id" class="detail-item">
              <div class="detail-item__meta"><strong>{{ item.productName }}</strong><small>{{ item.specificationText || '默认规格' }}</small></div>
              <div class="detail-item__right"><span>x{{ item.quantity }}</span><strong>{{ formatAmount(item.totalAmount) }}</strong></div>
            </div>
          </div>
        </article>
      </div>
      <article class="detail-card detail-card--full">
        <h3>状态处理</h3>
        <div class="detail-actions">
          <GuidedField label="订单状态" hint="选择订单下一步要流转到的状态。" required>
            <el-select v-model="statusForm.status" placeholder="请选择订单状态">
              <el-option v-for="option in orderStatusOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </GuidedField>
          <GuidedField label="流转备注" hint="记录本次处理原因，选填。">
            <el-input v-model.trim="statusForm.remark" placeholder="如 用户电话确认后改为配送" />
          </GuidedField>
          <el-button type="primary" :loading="statusSubmitting" @click="emit('submitOrderStatus')">更新状态</el-button>
        </div>
      </article>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="refundAuditVisible"
    title="退款审核"
    width="720px"
    @update:model-value="emit('update:refundAuditVisible', $event)"
  >
    <template v-if="selectedRefund">
      <div class="detail-grid detail-grid--single">
        <article class="detail-card">
          <h3>退款信息</h3>
          <dl>
            <div><dt>退款单号</dt><dd>{{ selectedRefund.refundNo }}</dd></div>
            <div><dt>订单号</dt><dd>{{ selectedRefund.orderNo || selectedRefund.orderId }}</dd></div>
            <div><dt>用户 ID</dt><dd>{{ selectedRefund.userId }}</dd></div>
            <div><dt>退款渠道</dt><dd>{{ getRefundChannelText(selectedRefund.channel) }}</dd></div>
            <div><dt>退款状态</dt><dd>{{ getRefundStatusText(selectedRefund.status) }}</dd></div>
            <div><dt>申请时间</dt><dd>{{ selectedRefund.createdAt }}</dd></div>
            <div><dt>退款金额</dt><dd>{{ formatAmount(selectedRefund.amount) }}</dd></div>
            <div><dt>退款原因</dt><dd>{{ selectedRefund.reason || '--' }}</dd></div>
          </dl>
        </article>
      </div>
      <article class="detail-card detail-card--full">
        <h3>审核处理</h3>
        <div class="detail-actions">
          <GuidedField label="审核结果" hint="通过后系统会按原支付渠道发起退款。" required>
            <el-select v-model="refundForm.result" placeholder="请选择审核结果">
              <el-option label="审核通过" value="APPROVED" />
              <el-option label="驳回退款" value="REJECTED" />
            </el-select>
          </GuidedField>
          <GuidedField label="审核备注" hint="驳回时建议填写具体原因，选填。">
            <el-input v-model.trim="refundForm.reason" placeholder="如 商品已制作，无法退款" />
          </GuidedField>
          <el-button type="primary" :loading="refundSubmitting" :disabled="!canAuditRefund(selectedRefund.status)" @click="emit('submitRefundAudit')">提交审核</el-button>
        </div>
        <p v-if="!canAuditRefund(selectedRefund.status)" class="detail-tip">当前退款单不在待审核状态，无法再次处理。</p>
      </article>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="verificationVisible"
    title="执行核销"
    width="560px"
    @update:model-value="emit('update:verificationVisible', $event)"
  >
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions detail-actions--store">
          <GuidedField label="核销码" hint="输入用户出示的券码或订单核销码。" required>
            <el-input v-model.trim="verificationForm.verifyCode" placeholder="请输入或粘贴核销码" />
          </GuidedField>
          <GuidedField label="订单 ID" hint="无法从核销码识别订单时填写，选填。">
            <el-input v-model.trim="verificationForm.orderId" placeholder="如 order_001" />
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:verificationVisible', false)">取消</el-button>
      <el-button type="primary" :loading="verificationSubmitting" @click="emit('submitVerification')">确认核销</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import GuidedField from '@/components/GuidedField.vue'
import type { AdminOrder, AdminRefund } from '@/api/order'
import type { VerificationPayload } from '@/api/verification'
import type { DeliveryType, OrderStatus, PaymentStatus, RefundStatus } from '@jiaofa/constants'

interface OrderStatusForm {
  status: OrderStatus | ''
  remark: string
}

interface RefundForm {
  result: 'APPROVED' | 'REJECTED'
  reason: string
}

interface OrderStatusOption {
  value: OrderStatus
  label: string
}

const props = defineProps<{
  orderDetailVisible: boolean
  refundAuditVisible: boolean
  verificationVisible: boolean
  selectedOrder?: AdminOrder
  selectedRefund?: AdminRefund
  statusForm: OrderStatusForm
  refundForm: RefundForm
  verificationForm: VerificationPayload
  orderStatusOptions: OrderStatusOption[]
  statusSubmitting: boolean
  refundSubmitting: boolean
  verificationSubmitting: boolean
  formatAmount: (amountInFen: number) => string
  getDeliveryTypeText: (type: DeliveryType) => string
  getOrderStatusText: (status: OrderStatus) => string
  getPaymentStatusText: (status: PaymentStatus) => string
  getRefundStatusText: (status: RefundStatus) => string
  getRefundChannelText: (channel?: string) => string
  canAuditRefund: (status: RefundStatus) => boolean
}>()

const emit = defineEmits<{
  'update:orderDetailVisible': [value: boolean]
  'update:refundAuditVisible': [value: boolean]
  'update:verificationVisible': [value: boolean]
  submitOrderStatus: []
  submitRefundAudit: []
  submitVerification: []
}>()

const {
  orderDetailVisible,
  refundAuditVisible,
  verificationVisible,
  selectedOrder,
  selectedRefund,
  statusForm,
  refundForm,
  verificationForm,
  orderStatusOptions,
  statusSubmitting,
  refundSubmitting,
  verificationSubmitting,
  formatAmount,
  getDeliveryTypeText,
  getOrderStatusText,
  getPaymentStatusText,
  getRefundStatusText,
  getRefundChannelText,
  canAuditRefund,
} = toRefs(props)
</script>

<style scoped lang="scss">
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.detail-grid--single { grid-template-columns: 1fr; }
.detail-card { padding: 16px; border: 1px solid var(--jf-color-border); border-radius: 12px; background: #fff; }
.detail-card--full { margin-top: 16px; }
.detail-card h3 { margin: 0 0 14px; font-size: 16px; }
.detail-card dl { margin: 0; display: grid; grid-template-columns: 1fr 1fr; gap: 12px 16px; }
.detail-card dl div { min-width: 0; }
.detail-card dt { margin-bottom: 4px; color: var(--jf-color-text-secondary); font-size: 12px; }
.detail-card dd { margin: 0; color: var(--jf-color-text-primary); font-size: 14px; word-break: break-all; }
.detail-items { display: flex; flex-direction: column; gap: 10px; }
.detail-item { padding: 12px; border-radius: 10px; background: rgba(252, 250, 246, .82); display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.detail-item__meta { min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.detail-item__meta strong, .detail-item__right strong { color: var(--jf-color-text-primary); }
.detail-item__meta small { color: var(--jf-color-text-secondary); }
.detail-item__right { display: flex; align-items: center; gap: 12px; }
.detail-actions { display: grid; grid-template-columns: 220px 1fr auto; gap: 12px; }
.detail-actions--store { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.detail-tip { margin: 12px 0 0; color: var(--jf-color-text-secondary); font-size: 12px; }
@media (max-width: 1180px) {
  .detail-grid, .detail-card dl, .detail-actions, .detail-actions--store { grid-template-columns: 1fr; }
}
</style>
